
import { Component, Vue, Watch } from 'vue-property-decorator'
import BackNav from '@/components/BackNav/index.vue'
import { editStoreInfo } from '@/api/store'
import { Debounce } from '@/core/decorator'
// import { toBaiDuMap } from '@/utils/h5ToApp'
import { Getter } from 'vuex-class'
// import AddressMap from '@/components/AddressMap/index.vue'

@Component({
  name: 'EditStoreAddress',
})
export default class EditStoreAddress extends Vue {
  @Getter companyId!: string
  address = ''
  receiveAddressDtl = ''
  errShakeClass = 'animate__animated animate__headShake'
  isShake = false
  longitude = ''
  latitude = ''
  jrAddress = ''

  created() {
    // 从sessionStorage获取初始值
    const addressInfoStr = window.sessionStorage.getItem('editStoreAddressInfo')
    if (addressInfoStr) {
      try {
        const addressInfo = JSON.parse(addressInfoStr)
        this.address = addressInfo.address || ''
        this.receiveAddressDtl = addressInfo.receiveAddressDtl || ''
        this.longitude = addressInfo.longitude || ''
        this.latitude = addressInfo.latitude || ''
        this.jrAddress = addressInfo.jrAddress || ''
      } catch (e) {
        console.error('解析sessionStorage地址信息失败:', e)
      }
    }
  }

  // 计算加权长度（汉字算2字符）
  getWeightedLength(val: string) {
    if (!val) return 0
    return Array.from(val).reduce((count, char) => {
      return count + (/[\u4e00-\u9fa5]/.test(char) ? 2 : 1)
    }, 0)
  }

  focusInput() {
    // 聚焦到详细地址输入框
    (this.$refs.detailAddressField as any)?.focus()
  }

  // 选择地址
  selectAddress() {
    // (this.$refs.addressMap as any).show()
    this.$router.push({
      path: '/addressMap',
      query: {
        longitude: this.longitude,
        latitude: this.latitude,
      }
    })
    // 调用原生方法选择地址
    // setTimeout(() => {
    //   toBaiDuMap().then((res: any) => {
    //     console.log('选择地址结果:', JSON.stringify(res))
        
    //     if (res) {
    //       // 更新地址信息
    //       this.address = res.address || ''
    //       this.receiveAddressDtl = res.addressDtl || ''
    //       this.longitude = res.longitude || ''
    //       this.latitude = res.latitude || ''
    //       this.jrAddress = res.address || ''
    //     }
    //   })
    // }, 100)
  }

  @Debounce(500)
  async onSave() {
    if (!this.address) {
      this.$toast('请选择所在地区')
      return
    }

    if (this.getWeightedLength(this.receiveAddressDtl) > 100 || !this.receiveAddressDtl.trim()) {
      this.isShake = true
      setTimeout(() => {
        this.isShake = false
      }, 1000)
      return
    }

    try {
      this.$toast.loading({
        message: '保存中...',
        duration: 0
      })

      const res = await editStoreInfo({
        storeId: this.companyId,
        address: this.address,
        receiveAddressDtl: this.receiveAddressDtl,
        longitude: this.longitude,
        latitude: this.latitude,
        jrAddress: this.jrAddress,
      })

      this.$toast.clear()

      if (res.code === '000000') {
        this.$toast.success('保存成功')
        setTimeout(() => {
          this.$router.back()
        }, 1000)
      } else {
        this.$toast.fail(res.msg || '保存失败')
      }
    } catch (e) {
      this.$toast.clear()
      console.error(e)
      this.$toast.fail('保存失败')
    }
  }
}
